// @flow

import { bpPassbookDashboardActions } from './bpPassbookDashboardActionCreator';

const initialState = {
  isLoading: false,
  isLoaded: false,
  dashboardData: [],
  dashboardDataFiltered: [],
  summaryData: null,
  balanceData: null
};

const filterDashboardTableData = (newState, searchStr) => {
  const searchString = searchStr.toLowerCase().trim();
  let filteredArr;
  if (searchString) {
    filteredArr = newState.dashboardData.filter(
      row =>
        (row.transactionHeader &&
          row.transactionHeader.toLowerCase().indexOf(searchString) >= 0) ||
        (row.transactionSubHeader &&
          row.transactionSubHeader.toLowerCase().indexOf(searchString) >= 0) ||
        (row.txnNo && row.txnNo.toLowerCase().indexOf(searchString) >= 0) ||
        (row.reference &&
          row.reference.toLowerCase().indexOf(searchString) >= 0)
    );
  } else {
    filteredArr = newState.dashboardData;
  }

  return filteredArr;
};

const bpPassbookDashboardReducer = (
  state: Object = initialState,
  action: Object
) => {
  switch (action.type) {
    case bpPassbookDashboardActions.GET_DASHBOARD_DATA: {
      return Object.assign({}, state, action.payload);
    }
    case bpPassbookDashboardActions.GET_SUMMARY_DATA: {
      return Object.assign({}, state, action.payload);
    }
    case bpPassbookDashboardActions.GET_BALANCE_DATA: {
      return Object.assign({}, state, action.payload);
    }
    case bpPassbookDashboardActions.FILTER_DASHBOARD_DATA: {
      const newState = Object.assign({}, state);
      const filtered = filterDashboardTableData(newState, action.payload);
      return Object.assign({}, state, { dashboardDataFiltered: filtered });
    }
    default: {
      return state;
    }
  }
};

export default bpPassbookDashboardReducer;
